module.exports = __webpack_public_path__ + "img/logo.9d3782d8.png";